import {ElMessage} from 'element-plus'

export default (error) => {
    let message

    if (error.message)
        if (Array.isArray(error.message)) message = error.message[0]
        else message = error.message

    if (!error.type || error.type === 'undefined error' || error.type === 'error') {
        ElMessage.error(message || 'Непредвиденная ошибка!')
        console.error(error)
        return
    }

    if (error.type === 'validate' || error.type === 'not found' || error.type === 'warning') {
        ElMessage({
            message: message,
            type: 'warning',
        })
        return
    }

    ElMessage.error('Отсутствует обработчик ошибки!')
    console.error(error)
}